import store from '../store';

/* Création des liens URL/Composant */
export const routes = [{
    path: '/experiences',
    name: 'experiences',
    component: () => import('../views/Experiences'),
    beforeEnter: (to, from, next) => {
        let timer = setInterval(function () {
            if (store.state.app.isPro === true) {
                next();
                clearInterval(timer);
            } else if (store.state.app.isPro === false) {
                if (store.getters['experience/experiences'][0].token) {
                    let value = '/experiences/' + store.getters['experience/experiences'][0].token;
                    next(value);
                    clearInterval(timer);
                }
            }
        }, 200);
    }
}, {
    path: '/experiences/:experienceToken',
    name: 'augmentations',
    component: () => import('../views/Augmentations')
}, {
    path: '/experiences/:experienceToken/augmentations/:augmentationToken',
    name: 'actions',
    component: () => import('../views/Actions')
}, {
    path: '/account',
    name: 'account',
    component: () => import('../views/Account')
}, {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/Contact')
}, {
    path: '/support',
    name: 'support',
    component: () => import('../views/Support')
}, {
    path: '/',
    redirect: '/experiences'
}];
